import { render, staticRenderFns } from "./ReportCenterTable.vue?vue&type=template&id=6337efbf&scoped=true&"
import script from "./ReportCenterTable.vue?vue&type=script&lang=js&"
export * from "./ReportCenterTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportCenterTable.vue?vue&type=style&index=0&id=6337efbf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6337efbf",
  null
  
)

export default component.exports